
export const phrases = {

  heading_settings_sort: 'Sortierung der Mitarbeiterliste',
  body_settings_sort: 'Mitarbeiterliste nach Vor- oder Nachnamen sortieren.',

since_o_clock: 'Seit {time} Uhr',

old_data_warning_my_area: 'Wir konnten keine neuen Informationen laden. Stelle sicher, dass du mit dem Internet verbunden bist.',
no_data_warning_my_area: 'Stelle sicher, dass du mit dem Internet verbunden bist und versuche es erneut.',
no_data_available_my_area: 'Es können keine Daten geladen werden',
last_update_data: 'Letzte Aktualisierung',

something_went_wrong_absences: 'Etwas ist schief gelaufen. Versuche es zu einem späteren Zeitpunkt bitte erneut.',
something_went_wrong_with_the_pin_entry: 'Mit der PIN-Eingabe ist etwas schief gelaufen...',
pin_must_be_four_digits: 'Die PIN muss aus genau vier Ziffern bestehen.',
pins_do_not_match: 'Die eingegebenen PINs stimmen nicht überein.',
pin_is_not_numerical: 'Die PIN darf nur aus Zahlen bestehen.',


  /** Phrasen für Task.getTechnicalNameFinish
   * -> müssen vermutlich irgendwann nochmal bearbeitet werden
   * z.B. 'Projekt beenden' macht eventuell keinen Sinn, wenn man das Projekt nicht beendet,
   * sondern nur die Arbeitszeit, die man auf dieses Projekt stempelt ?
   */
  finish_work_time: 'Ausstempeln',
  finish_break: 'Pause beenden',
  finish_loading_time: 'Ladezeit beenden',
  finish_driving_time: 'Fahrzeit beenden',
  finish_business_trip: 'Dienstgang beenden',
  finish_project_as_task: 'Projekt beenden',
  finish_special_one: 'Sonder1 beenden',
  finish_special_two: 'Sonder2 beenden',
  you_clockout: 'Du stempelst dich aus',

  sentence_work_time: 'Du arbeitest gerade. | Ihr arbeitet gerade.',
  sentence_break: 'Du machst gerade Pause. | Ihr macht gerade Pause.',
  sentence_loading_time: 'Du erfasst gerade Ladezeit. Hauruck! | Ihr erfasst gerade Ladezeit. Hauruck!',
  sentence_business_trip: 'Dienstgang eingeloggt. Viel Spaß!',
  sentence_driving_time: 'Du buchst gerade Fahrzeit. Anschnallen und los! | Ihr bucht gerade Fahrzeit. Anschnallen und los!',
  sentence_special_one: 'Du buchst gerade Sonder1. | Ihr bucht gerade Sonder1.',
  sentence_special_two: 'Du buchst gerade Sonder2. | Ihr bucht gerade Sonder2.',
  sentence_custom_time: 'Du buchst gerade | Ihr bucht gerade',

  you_are_booked_in_activity: 'Du stempelst {activity}! | Ihr stempelt {activity}!',
  substitute_warning: 'Bei Abwesenheiten ab { days } Tagen muss ein Vertreter angegeben werden.',
  substituted_by: 'Vertreten durch',
  name_clocked_in: '{name} eingestempelt',

  /************************************/
  //Signature stuff:

  signature: 'Unterschrift',
  please_sign: 'Bitte unterschreiben',
  signature_with_date: 'Unterschrift vom {date}',
  signature_with_date_with_name: 'Unterschrift vom {date} von {name}',
  signature_with_date_with_location: 'Unterschrift vom {date} in {location}',
  signature_with_date_with_name_with_location: 'Unterschrift vom {date} von {name} in {location}',
  signature_with_name: 'Unterschrift von {name}',
  signature_with_name_with_location: 'Unterschrift von {name} in {location}',
  signature_with_location: 'Unterschrift in {location}',


  /*************************************/

  accept_terms_and_conditions: 'Mit dem Absenden des Formulars akzeptierst Du unsere {agb} und unsere {datenschutzerklaerung}.',
  what_is_your_name: 'Wie heißt du?',
  your_email: 'Deine E-Mail-Adresse',
  what_is_your_company_name: 'Wie heißt dein Unternehmen?',
  what_do_you_want_to_do_with_clockin: 'Wie möchtest du Arbeitszeiten in clockin erfassen?',
  almost_finished: 'Fast geschafft',

  test_clockin_for_amount_period: 'Teste clockin {amountOfDaysTestPeriod} Tage kostenlos!',
  code_needed_to_connect:
    'Verwende deinen Code',
  you_have_no_company_code:
    'Du hast keinen Code? Wende dich an den Ansprechpartner in deinem Unternehmen.',
  connect_your_device: 'Verbinde Dein Gerät!',
  please_type_in_device_id:
    'Bitte gebe die Geräte-ID, die Du unter Mobilgeräte auf unserer Webseite finden kannst.',
  new_at_clockin: 'Neu bei clockin?',
  pin_repeat: 'PIN wiederholen',
  configure_your_pin: 'Lege deine 4-Stellige PIN fest',
  configure_your_pin_text: 'Den PIN benötigst du, um in Deinen Persönlichen Bereich am Tablet-Terminal zu gelangen.',
  congratulations: 'Herzlichen Glückwunsch!',
  start_now: 'Jetzt loslegen',
  device_name_info:
    'Du kannst den Gerätenamen deines Mobilgerätes ändern, damit du bei mehreren Geräten den Überblick behalten. Beispiel: „Smartphone MaxMustermann“. Der Name kann auch zu einem späteren Zeitpunkt geändert werden.',
  select_project: 'Projekt auswählen',
  select_time: 'Zeit auswählen',
  create_new_account: 'Neuen Account erstellen',
  join_my_company: 'Meinem Unternehmen beitreten',
  join_clockin_with_qr: 'Mit QR-Code beitreten',
  change_project: 'Projekt wechseln',
  my_messages: 'Meine Nachrichten',
  my_documents: 'Meine Dokumente',
  my_data_and_passwords: 'Meine Daten & Passwörter',
  my_account_data: 'Meine Daten',
  change_my_password: 'Passwort ändern',
  forgot_password: 'Ich kenne mein Passwort nicht.',
  open_camera: 'Kamera öffnen',
  scan_now: 'Jetzt scannen',
  sync_now: 'Jetzt synchronisieren',
  clear_logs: 'Logs leeren',
  saveAndGoBack: 'Speichern und zurück',
  full_day: 'Ganzer Tag',
  activate_scanner: 'Scanner wird aktiviert',
  scanner_is_inactive: 'Scanner inaktiv',
  change_project_by_scan_qr:
    'Scanne den QR-Code von dem Projekt in das du wechseln möchtest.',
  scan_device_by_qr:
    'Scanne den QR-Code von dem Gerät, welches du nutzen möchtest.',
  no_access_to_camera_please_connect_device_manually:
    'Leider war kein Zugriff auf die Kamera möglich, bitte gib den Geräte-Code manuell ein.',
  no_access_to_camera_please_clockin_manually:
    'Leider war kein Zugriff auf die Kamera möglich, bitte stempel dich manuell ein.',
  qr_code_login: 'QR-Code Anmeldung',
  scan_to_login: 'Scanne deinen QR-Code ein, um dich anzumelden.',
  checklist_was_saved: 'Checkliste wurde gespeichert',
  question_save_changes_short: 'Änderungen speichern?',
  question_save_changes: 'Möchtest du die Änderungen speichern?',
  question_delete_checklist_short: 'Checkliste löschen?',
  question_delete_checklist:
    'Bist du sicher, dass du die Checkliste löschen möchten?',
  checklist_is_sending: 'Checkliste wird versendet',
  checklist_sent_successfully: 'Checkliste erfolgreich versendet 🎉',
  checklist_could_not_be_sent: 'Checkliste konnte nicht versendet werden, versuche es später erneut.',
  checklist_transmission_problems_in_the_past: 'In der Vergangenheit gab es Übertragungsprobleme mit einigen Dateien.',
  checklist_send_with_potential_data_loss: 'Möchtest du versuchen die Checkliste ohne diese Dateien zu versenden?',
  documentation_is_sending: 'Projektdokumentation wird gesendet...',
  documentation_sent_successfully: 'Projektdokumentation erfolgreich versendet 🎉',
  confirm_documentation_dismissal : 'Möchtest du die Dokumentation wirklich verwerfen?',
  discard_unsaved_changes: 'Möchtest du deine Änderungen verwerfen?',
  documentation_will_be_sent_when_online: 'Die Dokumentation wird gesendet, sobald du wieder online bist.',
  confirmation_is_sending: 'Projektbestätigung wird gesendet',
  ask_for_geo_permission:
    'Diese App benötigt deinen Standort, ' +
    'aber es fehlt die Erlaubnis dazu.\n\n' +
    'Möchtest du die Einstellungen öffnen?',
  all_projects: 'Alle Projekte',
  half_day: 'Halber Tag',
  start_end: 'Nach Uhrzeit',
  my_area: 'Mein Bereich',
  my_area_video_teaser_clockin_explained_by_frederik: 'clockin erklärt von Freddi',
  add_time: 'Zeit anlegen',
  show_times_in_confirmation: 'Zeiten in Bestätigung anzeigen',
  change_time: 'Zeit ändern',
  finish_project: 'Projekt abschließen',
  finish_project_date: 'Termin abschließen',
  unfinish_project: 'Projekt wiedereröffnen',
  unfinish_project_date: 'Termin wiedereröffnen',
  absence_overview: 'Abwesenheiten verwalten',
  edit_absence: 'Abwesenheit bearbeiten',
  edited_absence: 'Abwesenheit bearbeitet',
  created_absence: 'Abwesenheitsantrag erfolgreich angelegt',
  creating_absence: 'Dein Abwesenheitsantrag wird jetzt angelegt',
  error_creating_absence: 'Fehler beim Anlegen des Abwesenheitsantrages',
  create_absence: 'Abwesenheit anlegen',
  deleted_absence: 'Abwesenheitsantrag zurückgezogen',
  new_request: 'Neuer Antrag',
  your_requests: 'Deine Anträge',
  planned_days: 'Verplante Tage',
  planned_hours: 'Verplante Stunden',
  used_days: 'Verbrauchte Tage',
  used_hours: 'Verbrauchte Stunden',
  free_days: 'Freie Tage',
  free_hours: 'Urlaubsstunden',
  open_days: 'Offene Tage',
  open_hours: 'Offene Stunden',
  withdraw_request: 'Antrag zurückziehen',
  change_request: 'Antrag ändern',
  request_was_approved: 'Dein Antrag wurde genehmigt',
  request_is_pending: 'Dein Antrag wurde noch nicht genehmigt',
  request_was_rejected: 'Dein Antrag wurde abgelehnt',
  add_attachment: 'Anhang hinzufügen',
  message_optional: 'Nachricht (optional)',
  filed_on: 'Eingereicht am',
  this_year: 'Dieses Jahr',
  search_sub_projects: 'An welchem Unterprojekt möchtest du arbeiten?',
  error_occurred: 'Ein Fehler ist aufgetreten, versuche es später erneut.',
  re_record: 'Dieses Video löschen und neu aufnehmen?',
  delete_video: 'Aufnahme löschen?',
  no_results_found: 'Keine Ergebnisse gefunden',
  record_again: 'Nochmal versuchen',

  request_valid_email: 'Bitte gib eine gültige E-Mail-Adresse ein.',
  request_valid_company_name: 'Bitte gib einen gültigen Unternehmensnamen ein.',
  request_valid_first_name: 'Bitte gib einen gültigen Vornamen ein.',
  request_valid_last_name: 'Bitte gib einen gültigen Nachnamen ein.',

  total_duration_today: 'Gesamtzeit heute',
  show_daily_protocol: 'Tagesprotokoll anzeigen',
  change_profile_pic: 'Profilbild ändern',
  logout_account: 'Account trennen',
  you_are_working: 'Du arbeitest gerade!',
  you_are_taking_a_break: 'Du machst gerade Pause!',
  activity_edited: 'Tätigkeit bearbeitet',
  activity_edited_undo: 'Bearbeitung erfolgreich rückgängig gemacht',
  activity_edited_missing_project: 'Oh, es fehlt noch das Projekt!',
  activity_deleted: 'Tätigkeit gelöscht',
  activity_deleted_undo: 'Gelöschte Tätigkeit wiederhergestellt',
  activity_created: 'Neue Tätigkeit erstellt',
  activity_created_undo: 'Neu erstellte Tätigkeit zurückgezogen',
  correct_working_hours: 'Arbeitszeiten korrigieren',
  your_changes_are_being_saved: 'Deine Änderungen werden jetzt gespeichert.',
  manage_working_hours: 'Arbeitszeiten verwalten',
  delete_activity: 'Tätigkeit löschen',
  start_navigation: 'Navigation starten',
  no_valid_email: 'Die eingegebene E-Mail Adresse ist nicht gültig.',
  delete_checklist: 'Checkliste löschen',
  active_checklists: 'Aktive Checklisten',
  scan_qr_code: 'QR-Code scannen',
  switch_to_office_center: 'Ins Bürocenter wechseln',
  confirm_project_completion_short: 'Projekt abschließen',
  confirm_project_date_completion_short: 'Termin abschließen',
  project_completed: 'Projekt abgeschlossen!',
  project_date_completed: 'Termin abgeschlossen!',
  confirm_project_uncompletion_short: 'Projekt wiedereröffnen',
  confirm_project_date_uncompletion_short: 'Termin wiedereröffnen',
  project_uncompleted: 'Projekt aktiviert',
  project_date_uncompleted: 'Termin aktiviert',
  choose_project: 'Projekt auswählen',
  choose_sub_project: 'Unterprojekt auswählen',
  choose_site: 'Standort auswählen',
  active_projects: 'Aktive Projekte',
  completed_term: 'abgeschlossen',
  completed_projects: 'Abgeschlossene projekte',
  end_of_work: 'Schönen Feierabend',
  correct_time: 'Zeit korrigieren',
  you_stamp_x: 'Du stempelst',
  enter_pin: 'Bitte PIN eingeben',
  wrong_pin: 'fehlerhafte PIN-Eingabe',
  pin_change_required: 'Du wurdest dazu aufgefordert deine PIN zu ändern',
  enter_new_pin: 'Neue PIN eingeben',
  approve_pin: 'PIN bestätigen',
  no_projects_scheduled: 'Für {day} sind keine Projekte hinterlegt.',
  you_clock_in_project: 'Du erfasst ab jetzt Projektarbeitszeit.',
  project_scan_error: 'Dieser Code ist für kein Projekt gültig.',
  show_more_days: 'weitere Tage anzeigen',
  show_more_times: 'Mehr Zeiten anzeigen',
  only_show_today: 'nur heute anzeigen',
  todays_total_time: 'Gesamtzeit heute',
  everything_synced: 'Deine Daten sind aktuell!',
  upload_in_progress: 'Die Daten werden hochgeladen...',
  who_are_you: 'Wer bist du?',
  is_uploading_to_server:
    'Deine Änderungen werden gerade an das Bürocenter übertragen.',
  offline_and_data_is_stored_locally:
    'Deine Änderungen werden bald an das Bürocenter übertragen. ',
  show_more: 'mehr anzeigen',
  activity_edited_wrong_date: 'Du hast ein falsches Datum eingegeben.',
  confirm_logout: 'Möchtest du dich wirklich abmelden?',
  confirm_clockout:
    'Bist du sicher, dass du dich für heute ausstempeln möchtest?',
  gps_is_active: 'GPS-Daten werden übermittelt',
  location_tracking_is_active: 'Um GPS-Tracking zu ermöglichen.',
  app_settings: 'App-Einstellungen',
  clock_reminder: 'Stempel - Erinnerung',
  mon_to_fri: 'Standard: Montags - Freitags',
  logout: 'Account trennen',
  refresh: 'Aktualisieren',
  prompt_language_settings: 'Stelle hier die Sprache der App ein.',
  prompt_clock_reminder: 'Erinnerung per Push-Benachrichtigung passend zu deinem Arbeitsalltag.',
  register_company: 'Unternehmen registrieren',
  use_code: 'Code verwenden',
  our_customers: 'Unsere Kunden',
  free_test_now: 'Jetzt kostenlos testen',
  tier_attendance: 'Ich erfasse nur Arbeitszeiten und Pausen.',
  tier_documentation: 'Ich möchte auch Arbeitszeiten auf Projekte buchen, die ich in clockin verwalte.',
  your_tier: 'Ihr Paket',
  all_clockin_functions: 'Alle clockin Funktionen',
  checklists_formulars: 'Checklisten & Funktionen',
  projectfile_incl_chat: 'Digitale Projektakten (inkl. Chat)',
  photo_sketch_note: 'Foto-, Skizzen & Notizfunktion',
  digital_signature: 'Digitale Unterschriften',
  datev_connection: 'DATEV-Anbindung',
  calendar_absences: 'Kalender & Abwesenheiten verwalten',
  individual_design: 'Individuelle Optik',
  attendance_time_tracking: 'Stationäre Zeiterfassung per Tablet-Terminal',
  mobile_time_tracking: 'Mobile Zeiterfassung per Smartphone-App',
  browser_time_tracking: 'Browser-Zeiterfassung am PC für Home-Office',
  help_use_code: 'Bitte gib den Code ein, den du im Bürocenter unter Mobilgeräte/Mitarbeiter findest.',
  wrong_code: 'Falscher Code',
  wrong_code_text: 'Der Code ist nicht gültig. Bitte versuche es mit einem gültigen Code erneut',
  wrong_code_text_short: 'Der Code ist ungültig',
  clockin_logo: 'Clockin Logo',
  invalid_qr_code: 'Ungültiger QR-Code',
  invalid_qr_code_text: 'Der gescannte QR-Code ist nicht gültig. Bitte scanne einen gültigen clockin-Code.',
  code_already_connected: 'Mit diesem Code kannst du dein Gerät verbinden. Du bist aber bereits verbunden.',
  wrong_credentials: 'Falsche Zugangsdaten',
  wrong_credentials_text: 'Die eingegebene Kombination aus E-Mail und Passwort konnte nicht gefunden werden. Bitte überprüfe deine Eingabe und versuche es erneut.',
  new_pin: 'Neue PIN eingeben',
  choose_next_action: 'Wähle deine nächste Aktion',
  name_of_software_package: 'Name des Software-Pakets',
  select_teamleader: 'Wer stempelt fürs Team?',
  select_teamleader_description: 'Um weiter Tätigkeiten zu Stempeln wähle bitte eine Person aus, die das Gerät jetzt übernimmt.',
  clocked_in_on_this_device: 'Auf diesem Gerät eingestempelt',
  not_clocked_in_on_this_device: 'Auf diesem Gerät nicht eingestempelt',
  select_new_teamleader: 'Wer soll jetzt fürs Team stempeln?',
  switch_teamleader: 'Gerät übergeben',
  just_me: 'Nur mich ausstempeln',
  select_the_new_teamleader: 'Lege den neuen Teamleiter fest',
  back_to_selection: 'zurück zur Auswahl',
  manage_team: 'Team verwalten',
  total_time_team: 'Gesamtzeit des Teams',
  count_members_clocked_in: '{clockedin}/{members} Teammitgliedern eingestempelt',
  whole_team: 'Gesamtes Team',
  teammembers_still_clockedin: 'Wähle aus, ob du nur dich oder alle im Team ausstempeln möchtest?',
  clockout_all: 'Alle Ausstempeln',
  select_employee: 'Wähle zunächst einen Nutzer aus',
  something_went_wrong: 'Etwas ist schief gelaufen, bitte versuche es später nochmal.',
  new_pin_successfully_changed: 'PIN erfolgreich geändert',
  enter_pin_before_clockin_prompt: 'Gebt zunächst einzeln eure PIN ein, um euch Einzustempeln.',
  enter_pin_before_clockout_prompt: 'Gebt zunächst einzeln eure PIN ein, um euch Auszustempeln.',
  delete_activity_alert_title: 'Tätigkeit löschen',
  delete_activity_alert_msg: 'Bist du dir sicher, dass du die Tätigkeit löschen möchtest?',
  delete_absence_message: 'Bist du dir sicher, dass du den Antrag zurückziehen möchtest?',
  delete_absence_title: 'Antrag zurückziehen',
  are_you_sure: 'Bist du dir sicher?',
  request_password: 'Neues Passwort anfordern',
  password_requested: 'Ein Link für ein neues Passwort wurde an deine E-Mail-Adresse gesendet',
  no_email_retrieved: 'Keine Mail erhalten? Bitte überprüfe deinen Spam-Ordner oder versuche es erneut.',
  name_of_customer: 'Name des Kunden',
  missing_permissions_homepage_text: 'Du hast nicht die  Berechtigung, um auf diesem Gerät deine Tätigkeit zu wechseln. Bitte wende dich an deinen Administrator, um Zugriff zu erhalten.',
  no_permission_warning_my_area: 'Du hast nicht die Berechtigung, um auf diesen Bereich zuzugreifen. Bitte wende dich an deinen Administrator, um Zugriff zu erhalten.',
  employee_clocked_in: '{name} angemeldet!',
  employee_clocked_out: '{name} abgemeldet!',
  no_employee_to_qr_code_warning: 'Zu diesem QR-Code konnte kein Mitarbeiter gefunden werden.',
  no_employees_registered_heading: 'Diesem Gerät wurden noch keine Mitarbeiter zugewiesen.',
  no_employees_registered_body: 'Im Bürocenter in den Mobilgeräteeinstellungen kannst du Mitarbeiter zuweisen, die dann auf diesem Gerät ihre Zeiten erfassen dürfen.',
  no_employee_found: 'Mit diesem Namen konnte leider niemand gefunden werden.',
  no_employee_assigned: 'kein Mitarbeiter zugewiesen',
  you_need_help: 'Du benötigst Hilfe?',
  here_you_can_get_help_to_register_employees_for_device: 'Hier findest du alle Informationen, wie man einem Gerät Mitarbeiter zuweist.',
  show_time: 'Zeit anlegen',
  export_timesheet: 'Stundenzettel exportieren',
  select_month: 'Monat auswählen',
  internet_connection_required: 'Hierfür wird eine Internetverbindung benötigt.',
  select_an_activity_to_clockin_your_team: 'Wähle eine Tätigkeit aus, um dein Team einzustempeln.',
  confirm_uploading_sqlite_for_debugging: 'Bist du sicher, dass du die Daten in der App für den Clockin-Support hochladen möchtest?',
  no_tasks_available: 'Keine Aufgaben verfügbar',
  click_to_add_tasks: 'Klicken um Aufgaben hinzuzufügen',
  scan_nfc_tag: 'Bitte halte deine Karte an das Lesegerät.',
  link_nfc_tag: 'NFC-Tag verknüpfen',
  select_employee_for_nfc_tag: 'Bitte wählen Sie einen Mitarbeiter aus, um diesen NFC-Tag zu verknüpfen:',
  nfc_tag_linked_successfully: 'NFC-Tag erfolgreich mit {name} verknüpft.',
  nfc_linking_failed: 'NFC-Tag konnte nicht verknüpft werden. Bitte versuchen Sie es erneut.',
  nfc_not_enabled: 'NFC wird von diesem Gerät nicht unterstützt oder ist deaktiviert.',
  nfc_initialization_failed: 'Da ist leider etwas schief gelaufen. Bitte versuchen Sie es erneut.',
  nfc_scan_failed: 'Da ist leider etwas schief gelaufen. Bitte versuchen Sie es erneut.',
  nfc_no_tag_found: 'Es wurde kein NFC-Tag gefunden.',
  nfc_tag_already_linked_to: 'Dieses NFC-Tag ist beriets mit {name} verknüpft.',
  nfc_scan_active: 'NFC Scan aktiv',
  nfc_linking_enabled: 'NFC-Tags können jetzt verknüpft werden. Bitte zu verknüpfendes NFC-Tag jetzt an den NFC-Reader halten.',
  nfc_all_employees_linked: 'Alle Mitarbeiter die diesem Gerät zugewiesen sind, wurden bereits verknüpft.',
  no_employee_to_nfc_warning: 'Zu diesem NFC-Tag konnte kein Mitarbeiter gefunden werden.',
  select_employee_to_link_nfc: 'Mit wem soll das NFC-Tag verknüpft werden?',
  new_onboarding: {
    personal_app_manager: {
      heading: {
        welcome: 'Willkommen in clockin',
        clocking_time: 'Zeiten erfassen',
        push_notifications: 'Nichts mehr vergessen'
      },
      text: {
        clocking_time: 'Der clocker ist dein Startpunkt für jede Tätigkeit. Du kümmerst dich um deine Arbeit, die App erledigt die Dokumentation.',
        push_notifications: 'Aktiviere jetzt die Benachrichtigungen. clockin erinnert dich, falls du eine Stempelung vergisst und stellt sicher, dass du alles wichtige sofort mitbekommst.'
      },
      button: {
        lets_go: 'Jetzt durchstarten',
      }
    },
    my_area: {
      heading: {
        my_area: 'Mein Bereich',
        absences: 'Abwesenheiten und Anträge',
        settings: 'Persönliche Einstellungen',
      },
      text: {
        my_area: 'Der zentrale Ort, an dem du deine Arbeitszeiten und Überstunden sofort im Blick hast. Von hier aus kannst du deine Arbeitszeiten verwalten, dein Tagesprotokoll aufrufen, Anträge einreichen und deine Zeiten einsehen.',
        absences: 'Verwalte Urlaubsanträge, Krankheitstage und andere Abwesenheiten. Behalte stets den Überblick über den Status deiner Anträge und reiche neue einfach und schnell mit nur wenigen Klicks ein.',
        settings: 'Sende Nachrichten im Unternehmen oder ändere deine persönlichen Einstellungen und falls du dein Passwort ändern möchtest, ist das hier auch möglich!',
      },
      button:{
        lets_go: 'Jetzt starten',
      }
    },
  },
  onboarding: {
    personal_app: {
      heading: {
        your_time_matters: 'Weil deine Zeit zählt',
        clock_in: 'Einstempeln',
        switch_task: 'Umstempeln',
        clock_out : 'Ausstempeln',
        thats_it: 'Das war’s!',
      },
      text: {
        your_time_matters: 'Mit clockin helfen wir dir dich aufs wesentliche zu konzentrieren. Erfasse deine Arbeitszeit ganz einfach mit nur einem Klick.',
        clock_in: 'Mit einem Klick bist du direkt eingestempelt. Clockin speichert deine Daten automatisch und du hast zu jeder Zeit alles im Blick.',
        switch_task: 'Du hast ein anderes Projekt, machst Pause oder fährst zu deinem nächsten Termin? Stempel dich einfach auf deine neue Aktivität um. Der Rest wird automatisch erfasst.',
        clock_out: 'Und mit einem Klick bist du ausgestempelt.',
        thats_it: 'Du hast es geschafft und bist bereit deine Arbeitszeit zu erfassen. Wenn du Hilfe benötigst, kontaktiere uns einfach. Bei clockin ist alles einfach - auch die Kommunikation mit uns.'
      },
      button:{
        your_time_matters: 'Zeig mir, wie\'s geht',
        thats_it: 'Jetzt durchstarten',
      }
    },
    team_app: {
      heading: {
        your_time_matters: 'Weil deine Zeit zählt',
        clock_in: 'Einstempeln',
        clock_in_team: 'Team einstempeln',
        switch_task: 'Umstempeln',
        change_teamleader: 'Gerät übergeben',
        clock_out : 'Ausstempeln',
        thats_it: 'Das war’s!',
      },
      text: {
        your_time_matters: 'Mit clockin helfen wir dir dich aufs wesentliche zu konzentrieren. Erfasse die Arbeitszeit deines Teams ganz einfach mit nur einem Klick.',
        clock_in: 'Wähle eine Person aus, die für das Team stempelt und mit einem Klick bist du direkt eingestempelt. clockin speichert deine Daten automatisch und du hast zu jeder Zeit alles im Blick.',
        clock_in_team: 'Stempel dein Team ganz einfach direkt ein. Egal ob alle gleichzeitig oder nur einzelne Mitglieder.',
        switch_task: 'Ihr habt ein anderes Projekt, macht Pause oder fahrt zu eurem nächsten Termin? Stempel einfach auf eure neue Aktivität um. Der Rest wird automatisch erfasst.',
        change_teamleader: 'Du machst Feierabend, musst weg oder stempelst nicht mehr für das Team? Übergib das Gerät einfach in der App und alles geht seinen normalen Weg.',
        clock_out: 'Und mit einem Klick bist du und dein Team ausgestempelt. Du kannst natürlich auch jederzeit einzelne Mitglieder ausstempeln.',
        thats_it: 'Du hast es geschafft und bist bereit die Arbeitszeit für dein Team zu erfassen. Wenn du Hilfe benötigst, kontaktiere uns einfach. Bei clockin ist alles einfach - auch die Kommunikation mit uns.'
      },
      button: {
        your_time_matters: 'Zeig mir, wie\'s geht',
        thats_it: 'Jetzt durchstarten',
      }
    },
    my_area: {
      heading: {
        welcome: 'Willkommen in deinem Bereich',
        my_area: 'Mein Bereich',
        create_time: 'Zeit anlegen',
        change_time : 'Zeit korrigieren',
        absences: 'Abwesenheiten und Anträge',
        settings: 'Persönliche Einstellungen',
        thats_it: 'Das war’s!',
      },
      text: {
        welcome: 'Entdecke jetzt noch mehr Möglichkeiten um deine Arbeitszeit effizient und einfach zu verwalten. Lass uns einen Blick auf  deinen Bereich verwefen.',
        my_area: 'Der zentrale Ort, an dem du deine Arbeitszeiten und Überstunden sofort im Blick hast. Von hier aus kannst du deine Arbeitszeiten verwalten, dein Tagesprotokoll aufrufen, Anträge einreichen und deine Zeiten einsehen.',
        create_time: 'Du hast vergessen eine Zeit zu erfassen oder möchtest nachträglich Zeiten hinzufügen? Kein Problem! Füge fehlende Zeiten hinzu, erfasse Pausen und behalte dein Arbeitszeitkonto immer aktuell.',
        change_time: 'Du möchtest deine Zeiten korrigieren? Kein Problem! Mit clockin kannst du falsche Zeiten ganz einfach korrigieren und anpassen.',
        absences: 'Verwalte Urlaubsanträge, Krankheitstage und andere Abwesenheiten. Behalte stets den Überblick über den Status deiner Anträge und reiche neue einfach und schnell mit nur wenigen Klicks ein.',
        settings: 'Sende Nachrichten im Unternehmen oder ändere deine persönlichen Einstellungen und falls du dein Passwort ändern möchtest, ist das hier auch möglich!',
        thats_it: 'Geschafft! Jetzt kannst du mühelos deine Zeiten verwalten, Abwesenheiten organisieren und dich auf das Wesentliche konzentrieren: deine Arbeit. Viel Erfolg bei deiner produktiven Zeit!'
      },
      button:{
        welcome: 'Zeig mir, wie\'s geht',
        thats_it: 'Jetzt durchstarten',
      }
    },
    clock: {
      clockin_now: 'Jetzt einclocken',
      clock_your_first_time_now: '& deine erste Zeit erfassen',
    }
  },
  surveys: {
    nps: {
      thanks_for_using_clockin: 'Danke, dass du clockin nutzt!',
      question: 'Wie wahrscheinlich ist es, dass Du clockin an Freunde oder Kollegen weiterempfiehlst?',
      very_likely: 'Sehr wahrscheinlich',
      very_unlikely: 'Sehr unwahrscheinlich',
      help_us_improve: 'Wie können wir clockin für dich verbessern?',
      what_do_you_agree_with: 'Welchen Aussagen würdest du zustimmen?',
      choose_three_statements: 'Wähle bis zu drei Aussagen aus.',
      hard_to_use: 'schwer zu bedienen',
      lacking_features: 'zu wenige Funktionen',
      does_not_help_me: 'erleichtert meinen Arbeitsalltag nicht',
      confusing: 'unübersichtlich',
      poorly_implemented: 'Funktionen schlecht umgesetzt',
      too_buggy: 'zu fehleranfällig',
      too_slow: 'lange Ladezeiten',
      what_else: 'Möchtest du uns noch etwas mitteilen?',
      can_we_ask_you_a_few_questions: 'Dürfen wir dir noch ein paar Fragen stellen?',
      how_happy_are_you_with_the_introduction_of_clockin: 'Wie glücklich bist du über die Einführung von clockin in deinem Unternehmen?',
      how_much_do_you_enjoy_using_clockin: 'Wie gerne nutzt du clockin?',
      how_much_easier_does_clockin_make_your_work: 'Wie sehr erleichtert clockin deine tägliche Arbeit?',
      how_happy_are_you_with_the_following_aspects: 'Wie zufrieden bist du mit den folgenden Punkten?',
      clarity_of_the_app: 'Übersichtlichkeit der App',
      simplicity_of_use: 'Einfachheit der Bedienung',
      app_features: 'Funktionen in der App',
      feedback_received: 'Dein Feedback ist angekommen. Danke, dass du dir die Zeit genommen hast.',
      thanks_for_taking_the_time: 'Danke, dass du dir die Zeit genommen hast.',
      what_can_we_do_to_improve: 'Kannst du uns mehr über deine Erfahrungen erzählen, damit wir es beim nächsten Mal noch besser machen können?',
      what_can_we_do_to_get_it_right: 'Kannst du uns mehr über deine Erfahrungen erzählen, damit wir es beim nächsten Mal richtig machen können?',
      comment_placeholder: 'Deine Nachricht',
    }
  },
  travel_logs: {
    add: 'Fahrtdetails hinzufügen',
    edit: 'Fahrtdetails bearbeiten',
    saving: 'Fahrtdetails werden gespeichert...',
    saved_successfully: 'Fahrtdetails erfolgreich gespeichert!',
    unable_to_save: 'Das hat leider nicht geklappt 😢'
  },
  attach_file: 'Datei anhängen',
  image_to_text: {
    info: 'Achte darauf, dass der Text gut zu erkennen und vollständig auf dem Bild zu sehen ist.',
    attach_image: 'Bild anhängen',
    processing: 'Dein Text wird eingelesen.',
    processing_failed: 'Leider hat das Einlesen nicht geklappt 😢',
    no_text_found: 'Es konnte kein Text erkannt werden.',
  },
  correction_enter_reason: 'Bitte gib einen Grund für die Korrektur an.',
  daily_notes:{
    add: 'Notiz schreiben',
    edit: 'Notiz bearbeiten',
    saving: 'Notiz wird gespeichert...',
    saved_successfully: 'Notiz erfolgreich gespeichert!',
    unable_to_save: 'Das hat leider nicht geklappt 😢',
    no_notes_yet: 'Keine Notiz erstellt',
    create_note: 'Erstellen',
  },
  calendar_sync: {
    title: 'Einsatzplan synchronisieren',
    description: 'Synchronisiere deinen Einsatzplan mit einem Kalender und behalte alte sowie neu Termine im Blick.',
    url: 'Adresse im iCal-Format',
    url_description:'Mit dieser Adresse kannst du von anderen Anwendungen aus auf diesen Kalender zugreifen.',
    note: 'Hinweis',
    note_description: 'Bei einigen Kalendern kann es bis zu 24 Stunden dauern bis neue Termine dort angezeigt werden.',
    sync_now: 'Kalender Synchronisieren',
    copied: 'Kalender-Url kopiert.'
  },
  registration: {
    skip_all: 'Alle überspringen',
    already_signed_up: 'Ich habe schon einen Account',
    title_1: 'Lass uns loslegen! Welche Zeiten möchtest du mit clockin erfassen?',
    description_1: 'Lass uns clockin auf dich anpassen',
    option_1_a:'Allgemeine Arbeitszeit (Kommen, Gehen & Pause)',
    option_1_b:'Projektarbeitszeiten',
    title_2: 'Möchtest du dokumentieren?',
    description_2: 'Welche Anforderungen müssen dafür erfüllt werden?',
    option_2_a:'Fotos',
    option_2_b:'Skizzen',
    option_2_c:'Notizfunktion',
    option_2_d:'Checklisten & Formulare',
    option_2_e:'Digitale Projektakten',
    title_3: 'Was möchtest du noch digitalisieren?',
    description_3: 'Es gibt noch viel mehr zu entdecken bei clockin, vielleicht ist etwas für dich dabei.',
    option_3_a: 'Urlaub',
    option_3_b: 'Krankheiten & Abwesenheiten',
    option_3_c: 'Digitale Personalakte',
    option_3_d: 'Unternehmensanalyse',
    option_3_e: 'Einsatzplanung',
    option_3_f: 'Datenübertragung Steuerberater (DATEV)',
    title_4: 'In welcher Branche ist dein Unternehmen tätig?',
    description_4: 'Wir wollen dich besser kennenlernen, um clockin mehr auf deine Bedürfnisse zuzuschneiden.',
    option_4_a: 'Dienstleistungen',
    option_4_b: 'Handwerk',
    option_4_c: 'Gesundheit und Wellness',
    option_4_d: 'Einkauf, Bestellen & Handel',
    option_4_e: 'Hotel und Gastronomie',
    option_4_f: 'Auto, Verkehr & Maschinen',
    option_4_g: 'Andere Branche',
    title_5: 'Wie viele Mitarbeiter sind Teil deines Unternehmens?',
    description_5: 'Mit der Anzahl an Mitarbeitern können wir clockin auf die Größe deines Unternehmens ausrichten.',
    title_6: 'Super! Dein clockin wird jetzt eingerichtet',
    description_6: 'Wir brauchen nur noch deinen Namen.',
    input_6_a: 'Firma',
    input_6_b: 'Vorname',
    input_6_c: 'Nachname',
    input_6_d: 'Telefonnummer',
    title_7: 'Es kann los gehen! Teste clockin 14 Tage kostenlos!',
    input_7_a: 'Deine E-Mail Adresse',
    description_7: 'An welche E-Mail-Adresse sollen wir dir dein Passwort schicken?',
    input_7_b: 'So bin ich aufmerksam geworden',
    how_did_you_hear_about_clockin: 'Wie hast du das erste Mal von clockin erfahren?',
    recommendation_option_1: 'Empfehlung',
    recommendation_option_2: 'Facebook',
    recommendation_option_3: 'Instagram',
    recommendation_option_4: 'Internetsuche',
    recommendation_option_5: 'LinkedIn',
    recommendation_option_6: 'Vergleichsplattform',
    recommendation_option_7: 'Zeitschrift & Online-Artikel',
    known_from: 'Bekannt aus',
    agb_1: 'Mit dem Absenden des Formulars akzeptierst du die ',
    agb_2: 'AGB',
    agb_3: ' und die ',
    agb_4: 'Datenschutzerklärung',
    start: 'Test starten',
    validation_failed: 'Bitte fülle alle Felder korrekt aus.',
  },
  clocki: {
    listening_heading: 'Ich höre Dir zu',
    listening_subtext: 'wie kann ich dir helfen?',
    hi_0: 'Moin, wie kann ich dir helfen?',
    hi_1: 'Hey, wie kann ich dir helfen?',
    hi_2: 'Hallo, wie kann ich dir helfen?',
    hi_3:'Moin moin, was kann ich für dich tun?',
    hi_4: 'Hi, was kann ich für dich tun?',
    hi_5: 'Grüß dich, wie kann ich dir helfen?',
    // hi_1: 'Hi {name}​, sag mir, wie kann ich dir helfen?',
    // hi_2: 'Hi {name}​, wie kann ich dir helfen?',
    // hi_3: 'Hi {name}​, was kann ich für dich tun?',
    // hi_4: 'Moin {name}​, was kann ich für dich tun?',
    // hi_5: 'Hallo {name}​, wie kann ich dir helfen?',
    // hi_6: 'Grüß dich {name}​, wobei kann ich dich unterstützen?',
    // hi_7: 'Guten Tag {name}​, womit kann ich dir heute helfen?',
    speech_recognition_unavailable: 'Leider scheint die Spracherkennung auf deinem Gerät nicht zu funktionieren​',
    microphone_permission_denied: 'Leider habe ich keinen Zugriff auf dein Mikrofon. Bitte überprüfe die Berechtigungen in den Einstellungen damit ich dich hören kann.',
    please_speak: 'Du kannst jetzt mit Clocki sprechen',
    create_activity: 'Aktivität anlegen',
    modify_activity: 'Aktivität ändern',
    delete_activity: 'Aktivität löschen',
    create_daily_note: 'Tagesnotiz anlegen',
    search_project: 'Projekt suchen',
    note_copied: 'Notiz kopiert',
    create_absence_request: 'Abwesenheit beantragen',
    delete_absence: 'Abwesenheit löschen',
    confirm_deletion: 'Bist du sicher, dass deine {activity_label} Stempelung vom {date} Uhr gelöscht werden soll?',
    confirm_absence_deletion: 'Bist du sicher, dass du deine Anfrage für {category} vom {startDate} bis {endDate} löschen möchtest?',
    task_before_modification: 'Vorher: {task}',
    starts_at_before_modification: 'Startzeit vorher: {startsAt}',
    ends_at_before_modification: 'Endzeit vorher: {endsAt}',
    something_went_wrong: 'Oh, da ist etwas schief gelaufen, bitte versuche es später nochmal.',
    was_this_helpful: 'Konnte Clocki dir weiterhelfen?',
    actions: {
      CREATE_ABSENCE: { 
        title: 'Abwesenheit bestätigen',
      },
      CREATE_DAILY_NOTE: {
        title: 'Jetzt Notiz anlegen',
        daily_notes_disabled: 'Leider ist die Notizfunktion deaktiviert. Bitte deinen Administrator, die Funktion im Bürocenter zu aktivieren.',
        success: 'Notiz erfolgreich im Tagesprotokoll gespeichert 🎉',
      },
      CREATE_PROJECT_NOTE: {
        title: 'Jetzt Dokumentation anlegen',
        created_by_clocki: 'Erstellt mit Clocki',
      },
      REDIRECT_TO_CORRECT_TIMES: {
        title: 'Jetzt "Meine Zeiten" öffnen',
      },
      REDIRECT_TO_MY_AREA: {
        title: 'Jetzt "Mein Bereich" öffnen',
      },
      REDIRECT_TO_CHANGE_PASSWORD: {
        title: 'Jetzt "Passwort ändern" öffnen',
      },
      CHANGE_ACTIVITY: {
        WORKING_TIME: 'Jetzt "Arbeitszeit" stempeln',
        PAUSE: 'Jetzt "Pause" stempeln',
        DRIVING_TIME: 'Jetzt "Fahrzeit" stempeln',
        LOGOUT: 'Jetzt ausclocken',
    }, 
  },
},
  review_prompt: {
    do_you_like_clockin: 'Benutzt du Clockin gerne?'
  },
  translation_failed: 'Die Übersetzung hat leider nicht geklappt 😕',
  video_transcript_not_available: 'Kein Transkript verfügbar',
  video_upload_succeeded: 'Video-Upload abgeschlossen.',
  video_upload_failed: 'Video-Upload fehlgeschlagen.',
  video_send_failed: 'Das Video konnte gerade nicht gesendet werden. Wir versuchen es später erneut.',
  uploading_video: 'Video wird hochgeladen...',
  language_selection_header: 'Sprache auswählen',
  language_selection_message: 'Wähle deine bevorzugte Sprache',
  shifts: {
    my_shifts: 'Meine Schichten',
    free_shifts: 'Freie Schichten',
    next_shift: 'Deine nächste Schicht',
    active_shift: 'Deine aktuelle Schicht',
    shift_not_found: 'Keine Schichten gefunden',
    show_shift_plan:'Diesen Schichtplan anzeigen',
    no_shift_place:'Kein Ort angegeben',
    no_shifts_assigned: 'Du bist aktuell auf keiner Schicht eingeteilt',
    free_shifts_unavailable: 'Freie Schichten sind derzeit nicht verfügbar',
    filter_shift_plans: 'Schichtpläne filtern',
    no_shift_plans_available: 'Keine Schichtpläne verfügbar',
    filter_locations: 'Orte filtern',
    no_locations_available: 'Keine Orte verfügbar',
    no_plan_selected: 'Kein Schichtplan ausgewählt',
    no_shifts_for_plan: 'Keine Schichten für diesen Plan gefunden',
    no_shifts_for_location: 'Keine Schichten für den ausgewählten Ort gefunden',
    unknown_shift_plan: 'Unbekannter Schichtplan',
    unknown_location: 'Unbekannter Ort',
    loading_more_shifts: 'Lade weitere Schichten...',
  },
  clockin_reminder_title: 'Schon am Arbeiten? 🔔',
  clockin_reminder: 'Denk daran, dich einzustempeln.',
  clockout_reminder_title: 'Bist du schon im Feierabend? 🔔',
  clockout_reminder: 'Vergiss nicht, dich auszustempeln.',
  choose_clockin_reminder_time: 'Einstempel-Erinnerungszeit',
  choose_clockout_reminder_time: 'Ausstempel-Erinnerungszeit',
  choose_break_reminder_time: 'Pausen-Länge',
  saved_successfully: 'Erfolgreich gespeichert 👍',
  clock_reminder_channel_name: 'Stempel-Erinnerungen',
  clock_reminder_channel_description: 'Erinnerungen zum Ein- und Ausstempeln',
  break_reminder_title: 'Machst du noch Pause? ⏰',
  break_reminder: 'Hinweis: Deine Pausenzeit läuft noch.',

  // Video component translations
  video_not_supported: 'Ihr Gerät unterstützt das Video nicht :/',
  video_loading_error: 'Fehler beim Laden des Videos',
  video_retry: 'Neuladen',
}
